module.exports = "/_next/static/images/female-seated-toilet@2x-min-4e56c57a6d21aba08d27a5a5a3f99651.jpg.webp";